import styled from 'styled-components';

import { GridBodyContainer } from './Body';
import { GridColumnContainer } from './Column';
import { GridFooterContainer } from './Footer';
import { GridHeaderContainer } from './Header';
import { GridRowContainer } from './Row';

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-content: start;
  background: var(--neutral-10);

  ${GridHeaderContainer} {
    border-bottom: solid 1px var(--neutral-200);
  }

  ${GridHeaderContainer} ${GridColumnContainer} {
    min-height: 40px;
  }

  ${GridFooterContainer} {
    border-top: solid 1px var(--neutral-200);
  }

  ${GridBodyContainer} ${GridRowContainer} {
    border-bottom: solid 1px var(--neutral-200);
  }

  ${GridBodyContainer} ${GridColumnContainer} {
    min-height: 60px;
  }

  ${GridBodyContainer} ${GridRowContainer}:first-child {
    border-top: solid 1px var(--neutral-200);
  }
`;
